<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    modal
    header="Preview New Changes"
    :style="{ width: '50vw' }">
    <div class="space-y-8">
      <div class="flex items-center gap-2">
        <InputText v-model="previewUrl" placeholder="https://..." size="large" class="flex-1" />
        <Button icon="pi pi-external-link" label="Open Preview" class="p-button-sm" @click="openPreview()" />
      </div>

      <div class="past-urls">
        <h3 class="text-lg font-bold">Preview with a previous URL:</h3>
        <ul class="space-y-4 pt-4">
          <li v-for="url in previewUrls.customUrls.value" :key="url" class="flex items-center justify-between">
            <div class="text-primary-500 flex items-center gap-2">
              <a
                :href="formatPreviewUrl(url) || '#'"
                target="_blank"
                rel="noopener noreferrer"
                class="text-lg underline">
                {{ url }}
              </a>
              <OpenIcon class="h-4 w-4 cursor-pointer" @click="openPreview(url)" />
            </div>
            <div>
              <DeleteIcon
                class="h-5 w-5 cursor-pointer opacity-50 hover:opacity-100"
                @click="previewUrls.removeCustomUrl(url)" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { ArrowTopRightOnSquareIcon as OpenIcon, TrashIcon as DeleteIcon } from '@heroicons/vue/24/outline'

defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  'update:visible': [value: boolean]
}>()

const configStore = useConfigStore()
const { currentTeamPid } = storeToRefs(configStore)
const previewUrls = usePreviewUrls({
  teamPid: currentTeamPid,
  isDemoMode: computed(() => false)
})

const previewUrl = ref('')

const openPreview = (targetUrl = previewUrl.value) => {
  if (!formatPreviewUrl(targetUrl)) {
    return
  }

  previewUrls.openPreviewUrl(targetUrl, 'custom')
  emit('update:visible', false)
}
</script>
